export const categories = [
    {
        id: 1,
        name: "Transformer"
    }
    ,
    {
        id: 2,
        name: "Dragon Ball"
    },
    {
        id: 3,
        name: "One Piece"
    },
    {
        id: 4,
        name: "Naruto"
    },
    {
        id: 5,
        name: "Kimetsu no yaiba"
    },
    {
        id: 6,
        name: "My Hero Academia"
    },
    {
        id: 7,
        name: "Jujutsu Kaisen"
    },
    {
        id: 8,
        name: "Marvel Universe"
    },
    {
        id: 9,
        name: "DC Comics"
    },
    {
        id: 10,
        name: "Nendoroid"
    },
    {
        id: 11,
        name: "Genshin Impact"
    },

]